import React from "react"
import cn from "classnames"
import { Field, FieldRenderProps } from "react-final-form"
import Slider from "../controls/Slider";
import IconButton from "../controls/IconButton"
import { t } from "../../i18n";

interface SliderFieldProps {
  className?: string;
  id?: string;
  i18key?: string;
  mainLabel?: string;
  max: number;
  maxLabel?: string;
  min: number;
  minLabel?: string;
  name: string;
  showCurrentValue?: boolean;
  risingBg?: boolean;
  showMinMaxLabels?: boolean;
  step?: number;
  valueToString?: (n: number) => React.ReactNode;
}

const SliderWithButtonsField: React.FC<SliderFieldProps> = (props: SliderFieldProps) => {
  const {
    className, id, mainLabel, max, maxLabel, min, minLabel, name, showCurrentValue, showMinMaxLabels, step
  } = props;
  const valueToString = props.valueToString || String

  return (
    <Field
      className={className}
      max={max}
      min={min}
      name={name}
      step={step}
      type="number"
      render={({ className, input, max, min, step }: FieldRenderProps<number>): React.ReactNode => {
        const {value} = input
        const increase_period = (count: number) => {
          const new_period = value + count
          input.onChange(new_period > max ? max : new_period)
        }
        const decrease_period = (count: number) => {
          const new_period = value - count
          input.onChange(new_period < min ? min : new_period)
        }
        return (
          <div className={cn("SliderField", className)}>
            {(mainLabel || showCurrentValue) && (
              <div className="SliderField-labels">
                <div>{mainLabel}</div>
                <div>
                  <IconButton
                    className="hidden sm:inline-block"
                    onClick={ () => decrease_period(1) }
                    symbolId="minus-filled"
                    transparent
                  />
                  <div className="inline-block min-w-8r text-right sm:text-center">
                    {valueToString(value)}
                  </div>
                  <IconButton
                    className="hidden sm:inline-block"
                    onClick={ () => increase_period(1) }
                    symbolId="plus-filled"
                    transparent
                  />
                </div>
              </div>
            )}
            <Slider
              input={input}
              max={max as number}
              min={min as number}
              step={step as number}
            />
            {id && <input id={id} type="hidden" value={value}/>}
            {showMinMaxLabels &&
              <div className="SliderField-minMaxLabels hidden sm:flex">
                <div>{minLabel ?? valueToString(min)}</div>
                <div>{maxLabel ?? valueToString(max)}</div>
              </div>
            }
            <div className="flex sm:hidden justify-between mt-2">
              <div className="bg-pattens-blue flex items-center justify-between rounded-lg p-2">
                <IconButton onClick={() => decrease_period(12)} symbolId="minus-filled" />
                <span className="text-curious-blue text-sm px-2">{t("years_label")}</span>
                <IconButton onClick={() => increase_period(12)} symbolId="plus-filled" />
              </div>
              <div className="bg-pattens-blue flex items-center justify-between rounded-lg p-2 ml-2">
                <IconButton onClick={() => decrease_period(1)} symbolId="minus-filled" />
                <span className="text-curious-blue text-sm px-2">{t("months_label")}</span>
                <IconButton onClick={() => increase_period(1)} symbolId="plus-filled" />
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default SliderWithButtonsField
